import { __extends } from "tslib";
import { deserializeAws_json1_1PutRecordBatchCommand, serializeAws_json1_1PutRecordBatchCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutRecordBatchCommand = /** @class */ (function (_super) {
    __extends(PutRecordBatchCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRecordBatchCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutRecordBatchCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRecordBatchCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1PutRecordBatchCommand(input, context);
    };
    PutRecordBatchCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1PutRecordBatchCommand(output, context);
    };
    return PutRecordBatchCommand;
}($Command));
export { PutRecordBatchCommand };
//# sourceMappingURL=PutRecordBatchCommand.js.map